import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MySubject } from './my-subject';
import { Observable } from 'rxjs';
import { GlobalsService } from './globals';

@Injectable()
export class ToolboxService {

    checkView = new MySubject();

    constructor(private http: HttpClient, private globals: GlobalsService) {

    }

    listToolbox() {
        const sub = this.http.get(`${this.globals.apiUrl}/api/organizacion/toolboxes`).subscribe((resp: any) => {
            const ckeck = this.checkToolbox(resp.data);
            this.checkView.next(ckeck);
            sub.unsubscribe();
        }, (error: any) => {
            console.error('Error al consultar lista toolbox', error);
            if (error.status === 401) {
                this.checkView.next(undefined);
            } else {
                this.checkView.next(false);
            }
            sub.unsubscribe();
        });
    }

    get getCheckView(): Observable<any> {
        return this.checkView.asObservable();
    }

    checkToolbox(data) {
        let check = {check: false, message: null};
        data.asignados.map((element: any) => {
            if (element.url.indexOf('nc') > -1) {
                if (!element.activo) {
                    check = {
                        check: false,
                        message: 'No tienes licencia para usar está herramienta'
                    };
                } else if (!element.permitido) {
                    check = {
                        check: false,
                        message: 'No está autorizado para usar está herramienta'
                    };
                } else {
                    check = {
                        check: true,
                        message: null
                    };
                }
            }
        });
        return check;
    }

    listMenu() {
        return this.http.get(`${this.globals.apiUrl}/api/toolbox/menu/6`);
    }
}
